import {createContext} from 'use-context-selector';

export default createContext();
